import { PageInfo } from './../../../core/models/page-info';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PurchaseSearchResult } from 'src/app/core/models/transport-operation/purchase-search-result';
import { environment } from 'src/environments/environment';
import { PageResp } from 'src/app/core/models/page/page-response';
import { InboundProgressResp} from 'src/app/core/models/transport-operation/inbound-tracks-response';
import { AdDetailInfoResponse } from 'src/app/core/models/transport-operation/ad-detail-info-response';
import { AdHeaderInfoResponse } from 'src/app/core/models/transport-operation/ad-header-info-response';
import { VMIAdvisingQueryRequest } from 'src/app/core/models/transport-operation/vmi-advising-query-request';
import { VMIAdvisingQueryResult } from 'src/app/core/models/transport-operation/vmi-advising-query-result';
import { VMIAdvisingQueryDetailResult } from 'src/app/core/models/transport-operation/vmi-advising-query-detail-result';
import { VMIAdvisingQueryDetailRequest } from 'src/app/core/models/transport-operation/vmi-advising-query-detail-request';
import { SearchIQCDetailRequest } from 'src/app/core/models/transport-operation/search-iqc-detail-request';
import { SearchIQCDetailData } from 'src/app/core/models/transport-operation/search-iqc-detail-response';

@Injectable({
  providedIn: 'root'
})
export class AdvisingServiceService {

  constructor(
    private http: HttpClient,
  ) { }

  queryProgress(param: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/advising/progress`;
    return this.http.post(url, param);
  }

  // 改用動態 SQL
  // queryProgress(param: any): Observable<PageResp<PurchaseSearchResult>> {
  //   const url = `${environment.logisticsApiUrl}/advising/progress`;
  //   return this.http.post<PageResp<PurchaseSearchResult>>(url, param);
  // }

  inboundTracks(param:any): Observable<InboundProgressResp>{
    const url = `${environment.logisticsApiUrl}/logistics/inboundTracks`;
    return this.http.post<InboundProgressResp>(url,param);
  }

  queryAdDetailInfo(adNo: string): Observable<AdDetailInfoResponse[]>{
    const url = `${environment.logisticsApiUrl}/advising/queryAdDetailInfo/${adNo}`;
    return this.http.get<AdDetailInfoResponse[]>(url);
  }

  async queryAdHeaderInfo(adNoList: string[]): Promise<any> {
    const url = `${environment.logisticsApiUrl}/advising/queryWmsAdInfo`;
    return await this.http.post(url, adNoList).toPromise();
  }

  searchVMIAdvising(req: VMIAdvisingQueryRequest): Observable<PageResp<VMIAdvisingQueryResult>> {
    const url = `${environment.logisticsApiUrl}/advising/searchVMIAdvising`;
    return this.http.post<PageResp<VMIAdvisingQueryResult>>(url, req);
  }
  searchVMIAdvisingDetail(req: VMIAdvisingQueryDetailRequest): Observable<VMIAdvisingQueryDetailResult[]> {
    const url = `${environment.logisticsApiUrl}/advising/searchVMIAdvisingDetail`;
    return this.http.post<VMIAdvisingQueryDetailResult[]>(url, req);
  }

  uploadVMIAdFile(file: any): Observable<any> {
    let url = `${environment.logisticsApiUrl}/advising/uploadVMIAdFile`;

    const formData: FormData = new FormData();
    formData.append('file', file);

    let response = this.http.post(url, formData ,  {
      reportProgress: true,
      responseType: 'json'
    } );
    return response;
  }

  searchIQCDetail(req: SearchIQCDetailRequest): Observable<SearchIQCDetailData> {
    const url = `${environment.logisticsApiUrl}/advising/searchIQCDetail`;
    return this.http.post<SearchIQCDetailData>(url, req);
  }

  exportIQCDetail(req: SearchIQCDetailRequest): Observable<Blob> {
    const url = `${environment.logisticsApiUrl}/advising/exportIQCDetail`;
    return this.http.post(url, req, { responseType: 'blob' });
  }
}
